import { useTranslation } from "react-i18next"

import { Avatar, AvatarFallback, AvatarImage } from "@f2e/ui/components/base"
import { cn } from "@f2e/ui/lib/utils"

import { getAvatarName, getAvatarBackgroundColor } from "@/lib/utils"
import { useResourceUrl } from "@/hooks"
import { NoOwner, User } from "@/types"

export interface UserNameplateProps {
  className?: string
  user: User
  size: number
}

const UserNameplate = ({ className, user, size }: UserNameplateProps) => {
  const { t } = useTranslation()
  const avatarUrl = useResourceUrl(user.avatar)
  return (
    <div className={cn("flex items-center", className)}>
      <Avatar className={`h-${size} w-${size}`}>
        <AvatarImage
          src={avatarUrl}
          alt={user.name ?? ""}
          className="object-cover"
        />
        <AvatarFallback
          style={{
            backgroundColor: getAvatarBackgroundColor(user.email),
          }}
        >
          {getAvatarName(user.name)}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col h-full ml-4 items-start">
        <div className="text-lg">
          {user === NoOwner ? t("types.noOwner.name") : user.name}
        </div>
        <div className="text-sm text-slate-500">
          {user === NoOwner ? t("types.noOwner.email") : user.email}
        </div>
      </div>
    </div>
  )
}

export default UserNameplate
